var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#clip0_18_225)" },
      React.createElement("path", { d: "M10 20C4.48 20 0 15.52 0 10S4.48 0 10 0s10 4.48 10 10-4.48 10-10 10zm0-8.823c.585 0 1.059-.475 1.059-1.06V5.766a1.059 1.059 0 1 0-2.118 0v4.353c0 .584.474 1.059 1.059 1.059zm0 4.117a1.176 1.176 0 1 0 0-2.353 1.176 1.176 0 0 0 0 2.353z", fill: "#FF4C00" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "clip0_18_225" },
        React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" })
      )
    )
  );
});